import axios from "../axiosPlugin.js";

export const getKitchenPrinterDeviceListService = data => {
    return axios({
        url: "/api/sunmi/list",
        method: "get",
        data: {
            data,
        },
    });
};

export const addKitchenPrinterDeviceListService = data => {
    return axios({
        url: "/api/sunmi/addDevice",
        method: "post",
        data: {
            data,
        },
    });
};

export const updateKitchenPrinterDeviceListService = data => {
    return axios({
        url: "/api/sunmi/updateDevice",
        method: "post",
        data: {
            data,
        },
    });
};

export const deleteKitchenPrinterDeviceListService = data => {
    return axios({
        url: `/api/sunmi/delete/${data.id}`,
        method: "delete",
        data: {},
    });
};


